import React from "react";
import Box from "@mui/material/Box";
import SideNav from "../components/SideNav";
import Header from "../components/Header";

interface DefaultLayoutProps {
  children: React.ReactNode;
}

export const DefaultLayout: React.FC<DefaultLayoutProps> = ({ children }) => {
  const classes = {
    layoutContainer: {
      display: "flex",
      maxWidth: "100%",
      height: "100%",
    },
    layoutContentContainer: {
      flexGrow: 1,
      overflow: "hidden",
      position: "relative",
      display: "flex",
      flexDirection: "column",
    },
    layoutContent: {
      width: "100%",
      height: "100%",
      overflow: "auto",
    },
  };

  return (
    <Box sx={classes.layoutContainer}>
      <SideNav />
      <Box sx={classes.layoutContentContainer}>
        <Header />
        <Box sx={classes.layoutContent}>{children}</Box>
      </Box>
    </Box>
  );
};
